import axios from "axios";
import { toast } from "react-hot-toast";

// Single source of truth for the API origin. Set REACT_APP_BASE_URL per
// environment (.env / .env.production) — do not hardcode a tenant URL here.
const API_BASE_URL = process.env.REACT_APP_BASE_URL || window.location.origin;


const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Fixing token retrieval
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      // Trim any whitespace and ensure token is valid
      const cleanToken = token.trim();
      if (cleanToken) {
        config.headers.Authorization = `Bearer ${cleanToken}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;
      const currentPath = window.location.pathname;

      if (status === 401) {
        // Token expired or invalid. Clear the whole session and send the user
        // to the login page ("/"), not to a protected route.
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        localStorage.removeItem("userId");
        if (currentPath !== "/") {
          window.location.href = "/";
        }
      } else if (status === 403) {
        console.error("Forbidden! You don't have permission.");
        const errorMessage = error.response?.data?.message || error.response?.data?.error || '';
        
        // Check if it's a role-based access error
        if (errorMessage.toLowerCase().includes('role') || errorMessage.toLowerCase().includes('unauthorized')) {
          toast.error(
            errorMessage || "Access denied: Unauthorized role. You don't have permission to access this resource."
          );
        } else {
          toast.error(
            errorMessage || "Access denied! You don't have permission to perform this action."
          );
        }
      }
      else if (status >= 500) {
        console.error("Server error! Please try again later.");
        toast.error("Something went wrong on the server.");
      }
    } else {
      console.error("Network error or request failed.");
      toast.error("Network error or request failed.");
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;